export const BulkUploadType = {
    TSP: 'TSP',
    DRIVER_VEHICLE: 'DRIVER/VEHICLE',
};
